import { request } from '../utility/services/request';

export class Service {
	baseUrl = '';
	requestPrefixId = null;
	constructor(baseUrl, requestPrefixId = null) {
		this.baseUrl = baseUrl;
		this.requestPrefixId = requestPrefixId;
	}

	getList(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		const requestId = this.requestPrefixId && `${this.requestPrefixId}-get`;
		return request(
			'GET',
			`${this.baseUrl}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`,
			null,
			requestId
		);
	}

	getAll() {
		return request('GET', `${this.baseUrl}/all`);
	}

	getById(id) {
		return request('GET', `${this.baseUrl}/${id}`);
	}

	getCaidaById(id) {
		return request('GET', `${this.baseUrl}/caida/${id}`);
	}

	addDelitos(id, values) {
		return request('POST', `${this.baseUrl}/caida/delitos/${id}`, values, null);
	}

	getCaidasByFichaId(id) {
		return request('GET', `${this.baseUrl}/${id}/caidas`);
	}

	createDatosDeContacto(values) {
		return request('POST', `${this.baseUrl}/datos-de-contacto/create`, values, null);
	}

	create(values) {
		return request('POST', this.baseUrl, values, null);
	}

	update(id, values) {
		return request('PUT', `${this.baseUrl}/${id}`, values);
	}

	// prefixed with underscored because delete is a reserved word in javascript
	_delete(id) {
		return request('DELETE', `${this.baseUrl}/${id}`);
	}
}
